import {Collapse} from "bootstrap";
import Main from "@/ts/base/Main";

export default class MobileMenu {
	protected main: Main;
	protected siteHeader: HTMLElement | null;
	protected nav!: HTMLElement | null;
	protected toggleBtn!: HTMLElement | null;
	protected overlay!: HTMLElement | null;
	protected panel!: HTMLElement | null;

	constructor() {
		this.main = Main.Instance;

		this.siteHeader = this.main.getHeaderComponent()?.getElement() || null;
		if (!(this.siteHeader instanceof HTMLElement)) {
			return;
		}

		this.nav = this.siteHeader.querySelector("nav.mobile-navigation");
		if (!(this.nav instanceof HTMLElement)) {
			return;
		}

		this.toggleBtn = this.nav.querySelector(".hamburger");
		this.panel = this.nav.querySelector(".navigation-panel");
		this.overlay = document.querySelector("#MobileMenuOverlay");

		if (this.siteHeader && this.nav) {
			this.addHandlers();
			this.initCollapsibleItems();
		}
	}

	toggle(): void {
		if (!(this.toggleBtn instanceof HTMLElement)) {
			return;
		}

		if (this.toggleBtn.classList.contains("active")) {
			this.toggleBtn.classList.remove("active");
			this.panel?.classList.remove("active");
			this.overlay?.classList.remove("active");
			window.document.body.classList.remove("mobile-nav-active");
		}
		else {
			this.toggleBtn.classList.add("active");
			this.panel?.classList.add("active");
			this.overlay?.classList.add("active");
			window.document.body.classList.add("mobile-nav-active");
		}
	}

	adjustPanelOffset(): void {
		if (!(this.siteHeader instanceof HTMLElement)) {
			return;
		}

		const headerCompStyle = window.getComputedStyle(this.siteHeader);
		const isHeaderFixed = headerCompStyle.position === "fixed";
		let offset;

		if (!isHeaderFixed) {
			offset = this.siteHeader.offsetTop + this.siteHeader.clientHeight - window.scrollY;
		}
		else {
			offset = this.siteHeader.clientHeight;
		}

		const height = window.innerHeight - this.siteHeader.clientHeight;

		if (this.panel instanceof HTMLElement) {
			this.panel.style.top = `${offset}px`;
			this.panel.style.height = `${height}px`;
		}

	}

	protected addHandlers(): void {
		if (this.toggleBtn) {
			this.toggleBtn.addEventListener("click", this.onToggle.bind(this));
		}
		if (this.overlay) {
			this.overlay.addEventListener("click", this.onToggle.bind(this));
		}


		window.addEventListener(Main.IsLoadedClass, () => {
			window.setTimeout(() => {
				this.panel?.classList.add("ready");
			}, 1000);
		});
	}

	protected initCollapsibleItems(): void {
		(<NodeListOf<HTMLLIElement>>this.nav?.querySelectorAll(`li[class*="children"]`))
			.forEach(item => {
				const toggle: HTMLButtonElement = document.createElement("button");
				const toggleIcon: HTMLElement = document.createElement("i");
				const aEl = item.querySelector("a");
				toggle.classList.add("toggle");
				toggle.type = "button";
				toggle.title = "Toggle Submenu"
				toggleIcon.classList.add("fas", "fa-angle-down");
				toggle.append(toggleIcon);

				aEl?.setAttribute("aria-expanded", "false");
				aEl?.setAttribute("aria-haspopup", "true");
				item.append(toggle);

				const submenu = toggle.previousElementSibling;
				if (submenu instanceof HTMLUListElement) {
					new Collapse(submenu, {
						toggle: false
					});
					submenu.classList.add("collapse");
				}

				toggle.addEventListener("click", this.onMenuItemClick.bind(this));
				aEl?.addEventListener("touchstart", this.onMenuItemTouch.bind(this), {
					passive: false
				});
			});
	}

	protected onMenuItemClick(e: Event): void {
		const toggle = <HTMLElement>e.currentTarget;
		const childMenu = toggle.previousElementSibling;

		if (childMenu) {
			const collapse = Collapse.getInstance(childMenu);
			collapse?.toggle();
		}
	}

	protected onMenuItemTouch(e: Event) {
		const ul = (<HTMLUListElement>e.currentTarget).closest("li")?.querySelector(".collapse");
		if (ul instanceof HTMLUListElement && !ul.classList.contains("show")) {
			e.preventDefault();
			const collapse = Collapse.getInstance(ul);
			collapse?.show();
		}
	}

	protected onToggle(e: Event) {
		e.preventDefault();
		this.adjustPanelOffset();
		this.toggle();
	}
}
